export interface ITalkTemplateProps {
  id?: string
  title: string | null
  body: string | null
  order: number | null
  createdAt: string | null
  updatedAt: string | null
}

export default class TalkTemplateEntity {
  private _props: ITalkTemplateProps

  constructor(props?: ITalkTemplateProps | null) {
    this._props = EmptyTalkTemplatePropsFactory(props)
  }

  get props(): ITalkTemplateProps {
    return this._props
  }

  get clone(): ITalkTemplateProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get title(): string | null {
    return this._props.title
  }

  get body(): string | null {
    return this._props.body
  }

  get order(): number | null {
    return this._props.order
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }
}

/** 1ユーザーあたりの登録上限 */
export const TALK_TEMPLATE_LIMIT = 5

/** タイトルの文字数上限 */
export const TALK_TEMPLATE_TITLE_MAX = 30

/** 本文の文字数上限 */
export const TALK_TEMPLATE_BODY_MAX = 1000

export const EmptyTalkTemplatePropsFactory = (props?: Partial<ITalkTemplateProps> | null): ITalkTemplateProps => ({
  title: null,
  body: null,
  order: null,
  createdAt: null,
  updatedAt: null,
  ...props
})
